import { createSelector } from 'reselect';
import { RootState } from 'Store/Reducers/RootReducer';

const getLessonStore = (state: RootState) => state.lessonStore;
const getLesson = createSelector(getLessonStore, (state) => state.lessons);
const startLesson = createSelector(getLessonStore, (state) => state.startLessons);

export { getLesson, startLesson };
